var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6002 8.00001L14.6002 2.74001C13.4614 1.72143 11.739 1.72143 10.6002 2.74001L4.60019 8.00001C3.95764 8.57468 3.59334 9.39799 3.60019 10.26V19C3.60019 20.6569 4.94334 22 6.60019 22H18.6002C20.257 22 21.6002 20.6569 21.6002 19V10.25C21.6042 9.39147 21.2401 8.57236 20.6002 8.00001ZM14.6002 20H10.6002V15C10.6002 14.4477 11.0479 14 11.6002 14H13.6002C14.1525 14 14.6002 14.4477 14.6002 15V20ZM19.6002 19C19.6002 19.5523 19.1525 20 18.6002 20H16.6002V15C16.6002 13.3432 15.257 12 13.6002 12H11.6002C9.94333 12 8.60018 13.3432 8.60018 15V20H6.60018C6.0479 20 5.60018 19.5523 5.60018 19V10.25C5.60055 9.9628 5.7244 9.6896 5.94018 9.50003L11.9402 4.25003C12.3177 3.91838 12.8827 3.91838 13.2602 4.25003L19.2602 9.50003C19.476 9.6896 19.5998 9.9628 19.6002 10.25V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.84f4ea12.svg";
export { ForwardRef as ReactComponent };